<div class= "animated fadeIn main">
    
    <div class="text-center border-bottom py-2">
    <i class="icon-round material-symbols-rounded">chat</i>
    <h1 class="my2-2">Bienvenidos</h1>
    <h2 class="">Tu opinión es muy importante para nosotros.</h2>
    </div>
    <div class="textoP my-4">
     
 <p class="mb-2">Respondé una breve encuesta sobre nuestros servicios utilizando la escala de estrellas.
 <br>Si algún aspecto no corresponde a tu caso, podés marcar “No aplica” o ampliar tu respuesta al final.
 </p>
</div>
<div class="text-center">
    <app-custom-button label="Empezar encuesta" 
                           button_style="outline"   
                           [newRoute]="['datos']">
    </app-custom-button>
</div>
        
</div>
